import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// Locales
import en from "./locales/en.json";
import es from "./locales/es.json";
import ro from "./locales/ro.json";

// En base de datos el idioma se guarda con el nombre en ingles
// (distributor.LANGUAGE_KEY: 'English', 'Spanish', ...), asi que hay que
// traducirlo al codigo que usa i18next. Un idioma sin entrada aqui cae al
// idioma por defecto en vez de romper la vista.
export const languageKeyToCode = {
  English: "en",
  Spanish: "es",
  Romanian: "ro",
};

export const defaultLanguage = "en";

export const availableLanguages = Object.values(languageKeyToCode);

// Formato de numeros y monedas segun el idioma de la pantalla.
export const languageCodeToLocale = {
  en: "en-GB",
  es: "es-ES",
  ro: "ro-RO",
};

export const getLanguageCode = (languageKey) => languageKeyToCode[languageKey] || defaultLanguage;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    ro: { translation: ro },
  },
  lng: defaultLanguage,
  fallbackLng: defaultLanguage,
  interpolation: {
    // React ya escapa por su cuenta.
    escapeValue: false,
  },
});

export default i18n;
